import React, { useRef } from 'react';
import Modal from '../Modal/Modal';
import { CaseEntry } from './CaseChatEntry';
import CaseChatEntryFileToDocumentationWrapper from './CaseChatEntryFileToDocumentationWrapper';

interface CaseChatEntryFileToDocumentationModalProps {
	opened: boolean;
	onClose: any;
	entry: CaseEntry;
}

export default function CaseChatEntryFileToDocumentationModal(
	props: CaseChatEntryFileToDocumentationModalProps,
) {
	const { entry, opened, onClose } = props;

	return (
		<div>
			<Modal opened={opened} onClose={onClose}>
				<Modal.Header title={'base.saveToHealthDocumentation'} />
				<Modal.Content>
					<CaseChatEntryFileToDocumentationWrapper
						entry={entry}
						onSuccess={onClose}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
